export const environment = {
	production: false,
	enableDebug: false,
	apiUrl: 'https://test-api.phonics-advantage.com/gt',
	segment: {
		apiKey: 'IskVxk6lbE2EAcIrElvnzGVxOL2MmmP6',
		debug: false,
	},
	mock: false,
};
